import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const SituacaoFuncional = () => {
  const [situacoesFuncionais, setSituacoesFuncionais] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    situacao: '',
    descricao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarSituacoes = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/situacao-funcional`
      );
      if (!response.ok) {
        throw new Error('Erro ao buscar situações funcionais');
      }
      const data = await response.json();
      const formatadas = data.map((item) => ({
        id: item.id_situacao_funcional,
        situacao: item.nome_situacao_funcional,
        descricao: '',
        ativo: item.ativo
      }));
      setSituacoesFuncionais(formatadas);
    } catch (error) {
      console.error('Erro ao carregar situações funcionais:', error);
      alert(
        'Erro ao carregar situações funcionais. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSituacoes();
  }, []);

  const filteredSituacoesFuncionais = situacoesFuncionais.filter(
    (situacao) =>
      (situacao.situacao || '')
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      (situacao.descricao || '')
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      const payload = {
        nome_situacao_funcional: formData.situacao,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/situacao-funcional/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar situação funcional');
        }

        const atualizada = await response.json();

        setSituacoesFuncionais(
          situacoesFuncionais.map((situacao) =>
            situacao.id === editingId
              ? {
                  id: atualizada.id_situacao_funcional,
                  situacao: atualizada.nome_situacao_funcional,
                  descricao: situacao.descricao,
                  ativo: atualizada.ativo
                }
              : situacao
          )
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/situacao-funcional`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar situação funcional');
        }

        const criada = await response.json();

        setSituacoesFuncionais([
          ...situacoesFuncionais,
          {
            id: criada.id_situacao_funcional,
            situacao: criada.nome_situacao_funcional,
            descricao: formData.descricao,
            ativo: criada.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar situação funcional:', error);
      alert(
        'Erro ao salvar situação funcional. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (situacaoFuncional) => {
    setFormData({
      situacao: situacaoFuncional.situacao,
      descricao: situacaoFuncional.descricao,
      ativo: situacaoFuncional.ativo
    });
    setEditingId(situacaoFuncional.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      window.confirm(
        'Tem certeza que deseja excluir esta situação funcional?'
      )
    ) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/situacao-funcional/${id}`,
          {
          method: 'DELETE'
          }
        );

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir situação funcional');
        }

        setSituacoesFuncionais(
          situacoesFuncionais.filter((situacao) => situacao.id !== id)
        );
      } catch (error) {
        console.error('Erro ao excluir situação funcional:', error);
        alert('Erro ao excluir situação funcional. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      situacao: '',
      descricao: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const selecionada = situacoesFuncionais.find((s) => s.id === id);
    if (!selecionada) {
      return;
    }

    const novoAtivo = !selecionada.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/situacao-funcional/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_situacao_funcional: selecionada.situacao,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da situação funcional');
      }

      setSituacoesFuncionais(
        situacoesFuncionais.map((situacao) =>
          situacao.id === id ? { ...situacao, ativo: novoAtivo } : situacao
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status da situação funcional:',
        error
      );
      alert(
        'Erro ao atualizar status da situação funcional. Tente novamente.'
      );
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Situação Funcional</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
            disabled={saving}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Situação
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Situação Funcional' : 'Cadastrar Situação Funcional'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="situacao">Situação Funcional *</label>
              <input
                type="text"
                id="situacao"
                value={formData.situacao}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    situacao: e.target.value
                  })
                }
                required
                maxLength={60}
                placeholder="Digite a situação funcional"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    ativo: e.target.checked
                  })
                }
              />
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
                disabled={saving}
              >
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar situações funcionais..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando situações funcionais...'
                  : `${filteredSituacoesFuncionais.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Situação Funcional</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredSituacoesFuncionais.map((situacao) => (
                  <tr key={situacao.id}>
                    <td>{situacao.id}</td>
                    <td>{situacao.situacao}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={situacao.ativo}
                          onChange={() => handleToggleStatus(situacao.id)}
                          id={`toggle-${situacao.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(situacao)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(situacao.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredSituacoesFuncionais.length === 0 && !loading && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhuma situação funcional encontrada</h3>
                <p>
                  Tente ajustar os filtros de pesquisa ou cadastre uma nova
                  situação funcional.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SituacaoFuncional;
